import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from '@mui/material'

import { MotivationGapLegend } from '../MotivationGapLegend/MotivationGapLegend'

interface ComparisonDiagnosisLegendEntity {
  name: string
  /** App icon URL; falls back to the generic category badge when absent. */
  icon?: string
}

interface ComparisonDiagnosisLegendProps {
  source: ComparisonDiagnosisLegendEntity
  target: ComparisonDiagnosisLegendEntity
}

/**
 * Legend for the cross-game diverging-motivations diagnosis: the target
 * goalpost marker, the uncovered gap hatch, and the source goalpost marker.
 * Kept as its own component so it can render either inline above the diverging
 * cards ({@link ComparisonDiagnosis}) or hoisted into a section card header.
 */
export const ComparisonDiagnosisLegend: FC<ComparisonDiagnosisLegendProps> = ({ source, target }) => {
  const { t } = useTranslation('ua-insights')
  const theme = useTheme()

  return (
    <MotivationGapLegend
      items={[
        { variant: 'marker', color: theme.palette.primary.main, label: target.name, icon: target.icon, genericIcon: !target.icon },
        { variant: 'hatch', color: theme.palette.error.main, label: t('diagnosis_gap_label') },
        { variant: 'marker', color: theme.palette.secondary.main, label: source.name, icon: source.icon, genericIcon: !source.icon },
      ]}
    />
  )
}
